<ui-map-with-sidebar
    [mapItems]="(mapItems$ | async) ?? fallbackMapItems"
    [popupContentComponentType]="popupContentComponentType"
    (reloadMapData)="reloadMapData()"
>
    <ui-filter-mapper filters/>
    <ui-sport-map-item-details map-item-details
        [mapItem]="(detailViewItem$ | async) ?? undefined"
        (mapItemTriggeredById)="openMapItemById($event)"
    />
</ui-map-with-sidebar>
